import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../styles/theme/foundation/colors';
import { MonthNames } from '../util';

import BackIconGroup from './BackIconGroup';
import CalendarBody from './CalendarBody';
import ForwardIconGroup from './ForwardIconGroup';
import WeekdayHeader from './WeekdayHeader';

function Calendar({
  calendars,
  getBackProps,
  getForwardProps,
  getDateProps
}) {
  if (calendars.length) {
    return (
      <Box color={colors.greyScale['900']} height="inherit" width="inherit">
        {calendars.map(calendar => (
          <Box key={`${calendar.month}${calendar.year}`} width="100%">
            <Flex h="68px" justify="space-between" pt="10px" width="100%">
              <BackIconGroup calendars={calendars} getBackProps={getBackProps} />
              <Text fontSize="sm" fontWeight="semibold" lineHeight="40px">
                {MonthNames[calendar.month]}
                {' '}
                {calendar.year}
              </Text>
              <ForwardIconGroup calendars={calendars} getForwardProps={getForwardProps} />
            </Flex>
            <WeekdayHeader />
            <CalendarBody calendar={calendar} getDateProps={getDateProps} />
          </Box>
        ))}
      </Box>
    );
  }

  return null;
}

Calendar.propTypes = {
  /* Dayzed Data: array of each month's data */
  calendars: PropTypes.arrayOf(PropTypes.shape({})),
  /* Dayzed Data: function that returns props to be applied to back buttons */
  getBackProps: PropTypes.func,
  /* Dayzed Data: function that returns props to be applied to next buttons */
  getForwardProps: PropTypes.func,
  /* Dayzed Data: function that returns props to apply to date buttons/elements */
  getDateProps: PropTypes.func
};

export default Calendar;
